import {PrimeIcons} from "primereact/api";
import {useTranslation} from "react-i18next";

import type {ValueOrderData} from "@reva/shared/value-order";

import {DetailsPanel, DetailsPanelRow, DetailsPanelSeparator} from "../../component/panels";

interface PanelObjectProps {
    orderData: ValueOrderData;
}

export function PanelObject({orderData}: PanelObjectProps) {
    const {t} = useTranslation();

    const addr = orderData?.orderDetails?.addressInformation;

    const streetHouseNr = addr?.houseNumber ? `${addr.street} ${addr.houseNumber}` : addr?.street;

    return (
        <DetailsPanel icon={PrimeIcons.BUILDING} title={t("order.object.title")}>
            <DetailsPanelRow label={t("order.object.streetHouseNr")} value={streetHouseNr} />
            <DetailsPanelRow label={t("order.object.addressAddition")} value={addr?.addressAddition} />
            <DetailsPanelRow label={t("order.object.zipCode")} value={addr?.zipCode} />
            <DetailsPanelRow label={t("order.object.city")} value={addr?.city} />
            <DetailsPanelRow label={t("order.object.district")} value={addr?.district} />
            <DetailsPanelRow label={t("order.object.state")} value={addr?.state} />

            {addr?.isDevelopmentArea && (
                <>
                    <DetailsPanelSeparator />
                    <DetailsPanelRow icon={PrimeIcons.CHECK_SQUARE} value={t("order.object.isDevelopmentArea")} />
                </>
            )}

            {addr?.referenceAddress && (
                <>
                    <DetailsPanelSeparator />
                    <DetailsPanelRow label={t("order.object.referenceAddress")} value={addr.referenceAddress} />
                </>
            )}
        </DetailsPanel>
    );
}
